import { ComponentInstance, ComponentLifecycleEvent } from './types';

import { ComponentLifecycleTracker } from './ComponentLifecycleTracker';
import { ConsoleLoggerPlugin } from './plugins/ConsoleLoggerPlugin';
import { StateManagerPlugin } from './plugins/StateManagerPlugin';

// Create singleton instance
const componentLifecycleTracker = ComponentLifecycleTracker.getInstance();

// Export
export {
  componentLifecycleTracker,
  StateManagerPlugin,
  ConsoleLoggerPlugin,
  ComponentInstance,
  ComponentLifecycleEvent
};
